import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiChecklistAiAssistanceDialogComponent } from '@fi-shared/checklist/fi-checklist2-edit/checklist-ai-assistance/checklist-ai-assistance-dialog/checklist-ai-assistance-dialog.component';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { FormsModule } from '@angular/forms';
import { FiChecklistAIAssistanceCard } from '@fi-shared/checklist/fi-checklist2-edit/checklist-ai-assistance/checklist-ai-assistance-card/checklist-ai-assistance-card.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FiDirectivesModule } from '@fi-shared/fi-directives/fi-directives.module';
import { FiChecklistAiAssistancePromptSamplesSection } from '@fi-shared/checklist/fi-checklist2-edit/checklist-ai-assistance/checklist-ai-assistance-dialog/checklist-ai-assistance-prompt-samples-section/checklist-ai-assistance-prompt-samples-section.component';
import { FiDotLoaderModule } from '@fi-shared/fi-dot-loader/fi-dot-loader.module';
import { FiInfoBannerModule } from '@fi-shared/fi-info-banner/fi-info-banner.module';
import { FiChecklistAiRequestResult } from '@fi-shared/checklist/fi-checklist2-edit/checklist-ai-assistance/checklist-ai-assistance-dialog/checklist-ai-request-result/checklist-ai-request-result.component';
import { FiChecklistAiRequestEditor } from '@fi-shared/checklist/fi-checklist2-edit/checklist-ai-assistance/checklist-ai-assistance-dialog/checklist-ai-request-editor/checklist-ai-request-editor.component';
import { InfoIconModule } from '@fi-shared/info-icon/info-icon.module';
import { BrowserModule } from '@angular/platform-browser';
import { FiChecklistAiRequestResultGroup } from '@fi-shared/checklist/fi-checklist2-edit/checklist-ai-assistance/checklist-ai-assistance-dialog/checklist-ai-request-result/checklist-ai-request-result-group/checklist-ai-request-result-group.component';
import { MatRadioModule } from '@angular/material/radio';

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        FiLoadingModule,
        FormsModule,
        FiAppTextSharedModule,
        MatButtonModule,
        MatCardModule,
        MatIconModule,
        FiDirectivesModule,
        FiDotLoaderModule,
        FiInfoBannerModule,
        InfoIconModule,
        MatRadioModule,
    ],
    declarations: [
        FiChecklistAIAssistanceCard,
        FiChecklistAiAssistanceDialogComponent,
        FiChecklistAiAssistancePromptSamplesSection,
        FiChecklistAiRequestEditor,
        FiChecklistAiRequestResult,
        FiChecklistAiRequestResultGroup,
    ],
    exports: [FiChecklistAIAssistanceCard],
})
export class ChecklistAiAssistanceModule {}
